export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.role === "MANAGER") return true;
  return user.permission?.[permission] === true;
};